module.exports = "<div class=\"rewardsplus-container\">\r\n    <div class=\"rewardsplus-iconContainer\">\r\n        <img src=\"/images/trolley/icon-rewards-wow-logo.svg\">\r\n    </div>\r\n    <div class=\"rewardsplus-textContainer\">\r\n        <span class=\"rewardsplus-title\">{{ $ctrl.settings.everydayRewards.rewardsMembershipAppliedMessage }}</span><br>\r\n        <span class=\"rewardsplus-content\">{{ $ctrl.messageParts[0] }}<strong>{{ $ctrl.formattedPrice }}</strong>{{ $ctrl.messageParts[1] }}</span>\r\n    </div>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/shop/cart/cart-free-delivery-rewards-plus.component.html
// module id = 190
// module chunks = 0 1